<template>
  <div class="floating-bottom-bar">
    <div class="bar-inner">
      <button class="bar-btn register" @click="openRegisterModal">
        <span class="btn-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <line x1="19" y1="8" x2="19" y2="14"/>
            <line x1="16" y1="11" x2="22" y2="11"/>
          </svg>
        </span>
        <span class="btn-text">관심고객등록</span>
      </button>

      <button class="bar-btn video" @click="openVideoModal">
        <span class="btn-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="5 3 19 12 5 21 5 3"/>
          </svg>
        </span>
        <span class="btn-text">홍보영상보기</span>
      </button>

      <button class="bar-btn popup" @click="openSidePopup">
        <span class="btn-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <line x1="9" y1="3" x2="9" y2="21"/>
          </svg>
        </span>
        <span class="btn-text">레이원시티 입지 보기</span>
      </button>

      <button class="bar-btn more" @click="openMegaMenu">
        <span class="btn-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </span>
        <span class="btn-text">더 자세히보기</span>
      </button>
    </div>

    <!-- 관심고객등록 모달 -->
    <transition name="modal">
      <div v-if="showRegisterModal" class="modal-overlay" @click.self="closeRegisterModal">
        <div class="register-modal">
          <button class="modal-close" @click="closeRegisterModal">
            <span></span>
            <span></span>
          </button>
          <h3 class="modal-title">관심고객등록</h3>
          <p class="modal-desc">상담을 원하시면 아래 정보를 입력해주세요.</p>

          <form @submit.prevent="submitRegister" class="register-form">
            <div class="form-group">
              <label>이름</label>
              <input type="text" v-model="registerForm.name" placeholder="이름을 입력하세요" required />
            </div>
            <div class="form-group">
              <label>연락처</label>
              <div class="phone-inputs">
                <input type="tel" inputmode="numeric" ref="regPhone1" v-model="registerForm.phone1" placeholder="010" maxlength="3" required @input="onPhoneInput('phone1', 3, 'regPhone2')" />
                <span class="phone-dash">-</span>
                <input type="tel" inputmode="numeric" ref="regPhone2" v-model="registerForm.phone2" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone2', 4, 'regPhone3')" />
                <span class="phone-dash">-</span>
                <input type="tel" inputmode="numeric" ref="regPhone3" v-model="registerForm.phone3" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone3', 4, null)" />
              </div>
            </div>
            <div class="form-group checkbox">
              <label class="checkbox-label">
                <input type="checkbox" v-model="registerForm.agree" required />
                <span class="checkmark"></span>
                <span>개인정보 수집 및 이용에 동의합니다.</span>
              </label>
            </div>
            <button type="submit" class="submit-btn" :disabled="isSubmitting">
              {{ isSubmitting ? '등록 중...' : '상담 신청하기' }}
            </button>
          </form>
        </div>
      </div>
    </transition>

    <!-- 홍보영상 모달 -->
    <transition name="modal">
      <div v-if="showVideoModal" class="modal-overlay video-overlay" @click.self="closeVideoModal">
        <div class="video-modal">
          <button class="modal-close white" @click="closeVideoModal">
            <span></span>
            <span></span>
          </button>
          <div class="video-wrapper">
            <iframe
              v-if="showVideoModal"
              src="https://www.youtube.com/embed/yWVeR23uK6A?autoplay=1"
              title="청주 레이원시티 홍보관 상담센터 홍보영상"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'FloatingBottomBar',
  data() {
    return {
      showRegisterModal: false,
      showVideoModal: false,
      isSubmitting: false,
      registerForm: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        agree: false
      }
    }
  },
  methods: {
    openRegisterModal() {
      this.showRegisterModal = true
      document.body.style.overflow = 'hidden'
    },
    closeRegisterModal() {
      this.showRegisterModal = false
      document.body.style.overflow = ''
    },
    openVideoModal() {
      this.showVideoModal = true
      document.body.style.overflow = 'hidden'
    },
    closeVideoModal() {
      this.showVideoModal = false
      document.body.style.overflow = ''
    },
    openSidePopup() {
      window.dispatchEvent(new CustomEvent('open-side-popup'))
    },
    openMegaMenu() {
      window.dispatchEvent(new CustomEvent('open-mega-menu'))
    },
    onPhoneInput(field, maxLen, nextRef) {
      this.registerForm[field] = this.registerForm[field].replace(/[^0-9]/g, '')
      if (this.registerForm[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    async submitRegister() {
      if (!this.registerForm.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }

      this.isSubmitting = true

      try {
        await registerCustomer({
          name: this.registerForm.name,
          phone: `${this.registerForm.phone1}${this.registerForm.phone2}${this.registerForm.phone3}`
        })
        alert(`${this.registerForm.name}님, 상담 신청이 완료되었습니다.\n빠른 시일 내에 연락드리겠습니다.`)
        this.registerForm = { name: '', phone1: '010', phone2: '', phone3: '', agree: false }
        this.closeRegisterModal()
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.floating-bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 800;
  padding: 0 40px 24px;
  pointer-events: none;
}

.bar-inner {
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  gap: 12px;
  pointer-events: auto;
}

.bar-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 20px;
  border: none;
  border-radius: 8px;
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.bar-btn.register {
  background: var(--rayone-primary);
  color: #fff;
}

.bar-btn.register:hover {
  background: var(--rayone-primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(163, 32, 53, 0.3);
}

.bar-btn.video {
  background: #1a1a1a;
  color: #fff;
}

.bar-btn.video:hover {
  background: #000;
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.3);
}

.bar-btn.popup {
  background: #fff;
  color: #333;
  border: 1px solid #e5e5e5;
}

.bar-btn.popup:hover {
  background: #f5f5f5;
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
}

.bar-btn.more {
  background: linear-gradient(135deg, #2c3e50 0%, #1a252f 100%);
  color: #fff;
}

.bar-btn.more:hover {
  background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(44, 62, 80, 0.3);
}

.btn-icon {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-icon svg {
  width: 100%;
  height: 100%;
}

/* 모달 공통 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
  pointer-events: auto;
}

.modal-overlay.video-overlay {
  background: rgba(0, 0, 0, 0.9);
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.modal-close span {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 24px;
  height: 2px;
  background: #333;
  transition: background 0.3s ease;
}

.modal-close span:first-child {
  transform: translate(-50%, -50%) rotate(45deg);
}

.modal-close span:last-child {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.modal-close:hover span {
  background: var(--rayone-primary);
}

.modal-close.white span {
  background: #fff;
}

.modal-close.white:hover span {
  background: rgba(255, 255, 255, 0.7);
}

/* 관심고객등록 모달 */
.register-modal {
  position: relative;
  width: 100%;
  max-width: 440px;
  background: #fff;
  border-radius: 16px;
  padding: 48px 40px;
}

.modal-title {
  font-family: var(--font-pretendard);
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 8px;
}

.modal-desc {
  font-family: var(--font-pretendard);
  font-size: 14px;
  color: #888;
  text-align: center;
  margin-bottom: 32px;
}

.register-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.form-group input[type="text"],
.form-group input[type="tel"] {
  padding: 14px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-family: var(--font-pretendard);
  font-size: 15px;
  transition: border-color 0.3s ease;
}

.form-group input[type="text"]:focus,
.form-group input[type="tel"]:focus {
  outline: none;
  border-color: var(--rayone-primary);
}

/* 전화번호 3칸 */
.phone-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-inputs input {
  flex: 1;
  text-align: center;
  min-width: 0;
}

.phone-dash {
  color: #999;
  font-size: 16px;
  flex-shrink: 0;
}

.form-group.checkbox {
  margin-top: 8px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
}

.checkbox-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-radius: 4px;
  position: relative;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.checkbox-label input[type="checkbox"]:checked + .checkmark {
  background: var(--rayone-primary);
  border-color: var(--rayone-primary);
}

.checkbox-label input[type="checkbox"]:checked + .checkmark::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 6px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.submit-btn {
  margin-top: 12px;
  padding: 16px;
  background: var(--rayone-primary);
  border: none;
  border-radius: 8px;
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: background 0.3s ease;
}

.submit-btn:hover {
  background: var(--rayone-primary-dark);
}

/* 홍보영상 모달 */
.video-modal {
  position: relative;
  width: 100%;
  max-width: 900px;
}

.video-wrapper {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
}

.video-wrapper iframe {
  width: 100%;
  height: 100%;
}

/* 모달 트랜지션 */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-active .register-modal,
.modal-leave-active .register-modal,
.modal-enter-active .video-modal,
.modal-leave-active .video-modal {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .register-modal,
.modal-leave-to .register-modal,
.modal-enter-from .video-modal,
.modal-leave-to .video-modal {
  transform: scale(0.95);
  opacity: 0;
}
</style>
